const index = () => import('./Index');

//2021年生产性物流项目补助申请表
export default {
  routes: [
    {
      path: '/logistics/v2021/index',
      name: 'logistics_v2021_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/logistics/v2021/router.js